export enum AssetAvailabilityReason {
  METER_LIMIT = 'meter-limit',
  DNO_CONSTRAINT = 'dno-constraint',
  OM_VISIT = 'om-visit',
  OEM_VISIT = 'oem-visit',
  PERFORMANCE_DERATING = 'performance-derating',
  ASSET_FAULT_OR_OUTAGE = 'asset-fault-or-outage',
  FORCE_MAJEURE = 'force-majeure',
}
